import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';

Component('tr-todo-attachments', {
  mixins: [eventListenerMixin],

  properties: {
    url: {
      type: String,
    },
    uploadUrl: {
      type: String,
    },
    sync: {
      type: Boolean,
      value: false,
    },
    dataType: {
      type: String,
      default: 'script',
    },
  },

  tpl: {
    upload: `<div class="file uploading" id="file-upload-{{ id }}" attachid="{{ id }}">
              <div class="file-thumb"></div>
              <div class="file-main">
                <div class="file-name">{{ name | encodeHtml }}</div>
                <div class="file-info">
                  <div class="progress">
                    <div class='progress-bar'>
                      <div><span></span></div>
                    </div>
                    <a href='javascript:;' class='link-cancel'>取消</a>
                  </div>
                  <div class='error'>
                    <span class='error-desc'>上传失败</span>
                    <a href='javascript:;' class='link-cancel'>取消</a>
                  </div>
                </div>
              </div>
            </div>`,

    file: `<div class="file todo-attachment" id="file-upload-{{ id }}" attachid="{{ id }}">
            <div class="file-thumb"></div>
            <div class="file-main">
              <div class="file-name">{{ name | encodeHtml }}</div>
              <div class="file-info">
                <span>{{ size }}</span>
                <span class="file-toolbar">
                  <a href="{{ url }}" class="link-download" download>下载</a>
                  <a href="javascript:;" class="link-delete">删除</a>
                </span>
              </div>
            </div>
          </div>`,
  },

  connected() {
    this.button = $(this).find('#link-upload-attachments');
    this.uploadCount = 0;
    this.initUploader();
    this.bind();
  },

  initUploader() {
    this.uploader = window.simple.uploader({
      url: this.uploadUrl,
      params: {
        conn_guid: $('#conn-guid').val(),
        authenticity_token: $('meta[name=csrf-token]').attr('content'),
      },
    });

    window.tower.connectUploader(this.button, this.uploader, {
      title: '上传文件',
      multiple: true,
    });
  },

  bind() {
    const list = $(this).find('.file-list');

    this.uploader.on('beforeupload', (e, file) => {
      if (!window.tower.checkUploadFileSize(file)) {
        return false;
      }

      const fileEl = $(
        window.simple.tpl(this.tpl.upload, {
          id: file.id,
          name: file.name,
          size: this.renderSize(file),
        }),
      ).prependTo(list);

      this.namespacedTrigger('beforeupload', { bubbles: true });
      this.uploadCount += 1;

      this.renderThumb(file, fileEl);
      return true;
    });

    $(this).on('click', '.link-cancel', (e) => {
      const fileEl = $(e.currentTarget).closest('.file');
      const attachid = fileEl.attr('attachid');
      if (attachid && fileEl.hasClass('uploading')) {
        this.uploader.cancel(attachid);
      }
      fileEl.remove();
    });

    this.uploader.on('uploadprogress', (e, file, loaded, total) => {
      const fileEl = list.find(`.file[attachid=${file.id}]`);
      let percent = loaded / total;
      percent = percent > 0.99 ? '正在处理...' : `${(percent * 100).toFixed(0)}%`;
      fileEl.find('.progress-bar span').width(percent);
    });

    this.uploader.on('uploadsuccess', (e, file, result) => {
      list.find(`.file#file-upload-${file.id}`).replaceWith(
        window.simple.tpl(this.tpl.file, {
          id: result.attach,
          name: file.name,
          size: this.renderSize(file),
          url: result.file_path,
        }),
      );
      const fileEl = list.find(`.file#file-upload-${result.attach}`);
      this.renderThumb(file, fileEl, result.file_path);
      this.notifyChange();
    });

    this.uploader.on('uploadcomplete', () => {
      this.uploadCount -= 1;
      setTimeout(() => {
        if (this.uploadCount === 0) this.namespacedTrigger('uploadcomplete', { bubbles: true });
      }, 0);
      this.updateFiles();
    });

    this.uploader.on('uploaderror', (e, file, xhr) => {
      if (xhr.statusText === 'abort') return;
      const fileEl = list.find(`.file#file-upload-${file.id}`);
      fileEl.removeClass('uploading').addClass('uploaderror');
      fileEl.find('.progress').css('display', 'none');
      window.tower.uploaderror(xhr);
    });

    this.filedrop = window.simple
      .filedrop({
        el: this,
        hints: '拖拽到这里上传',
      })
      .on('drop', (e, files) => {
        if (files && files.length) {
          this.uploader.upload($.makeArray(files), {
            attachment: true,
          });
        }
      });

    list.on('click', '.link-delete', (e) => {
      if (!this.sync) {
        $(e.target).closest('.file').remove();
        this.notifyChange();
        return;
      }

      window.simple.dialog.confirm({
        content: e.target.dataset.confirmText || '确认删除任务附件吗？',
        callback: (event, confirm) => {
          if (!confirm) return;
          $(e.target)
            .closest('.file')
            .remove();
          this.updateFiles();
          this.notifyChange();
        },
      });
    });
  },

  notifyChange() {
    this.namespacedTrigger('attachmentsChange', { bubbles: true });
  },

  renderSize(file) {
    let size = 0;
    if (file.size >= 1048576) {
      size = `${(file.size / 1048576).toFixed(1)}M`;
    } else {
      size = `${(file.size / 1024).toFixed(0)}K`;
    }
    return size;
  },

  renderThumb(file, fileEl, filePath) {
    this.uploader.readImageFile(file.obj, (img) => {
      if (img) {
        fileEl.find('.file-thumb').append(`<img src="${filePath || img.src}"
          data-image-src="${filePath || img.src}"
          data-image-size="${img.width},${img.height}">`);
      } else {
        const path = `${process.env.OSS_ASSETS_ENDPOINT}/file_icons_v2/`;
        const imgPath = `${path}${file.ext}.svg`;

        window.simple.util.preloadImages(imgPath, (icon) => {
          const src = icon ? icon.src : `${path}other.svg`;
          fileEl.find('.file-thumb').append(`<img src="${src}">`);
        });
      }
    });
  },

  updateFiles() {
    if (!this.sync || this.uploader.uploading) return;
    if (this.request) this.request.abort();

    const attachments = this.querySelectorAll('.todo-attachment');
    let ids = '';

    if (attachments.length) {
      ids = Array.prototype.map.call(attachments, el => el.getAttribute('attachid'));
    }

    this.request = $.ajax({
      url: this.url,
      type: 'patch',
      dataType: this.dataType,
      data: {
        'todos_management[attfile_guids][]': ids,
      },
      success: (result) => {
        resourceSubject('todo').next('update', {
          id: result.id,
          rowData: { attachments: result.tableViewData.attachments },
        });
      },
    });
  },

  disconnected() {
    this.stopListening();
    if (this.filedrop) this.filedrop.destroy();
  },
});
